import { render, staticRenderFns } from "./SoftRate.vue?vue&type=template&id=123fa8b0&scoped=true"
import script from "./SoftRate.vue?vue&type=script&lang=js"
export * from "./SoftRate.vue?vue&type=script&lang=js"
import style0 from "./SoftRate.vue?vue&type=style&index=0&id=123fa8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123fa8b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
